import '@mantine/core/styles.css';
import { MantineProvider } from '@mantine/core';
import { createVipsoTheme } from './index';

export interface VipsoProviderProps {
  children: React.ReactNode;
  themeOverrides?: Parameters<typeof createVipsoTheme>[0];
  colorScheme?: 'light' | 'dark' | 'auto';
}

export function VipsoProvider({
  children,
  themeOverrides,
  colorScheme = 'light',
}: VipsoProviderProps) {
  const theme = createVipsoTheme(themeOverrides);
  return (
    <MantineProvider theme={theme} defaultColorScheme={colorScheme}>
      {children}
    </MantineProvider>
  );
}
